import { render, staticRenderFns } from "./McpModalCenter.vue?vue&type=template&id=23d26766&scoped=true&"
import script from "./McpModalCenter.vue?vue&type=script&lang=js&"
export * from "./McpModalCenter.vue?vue&type=script&lang=js&"
import style0 from "./McpModalCenter.vue?vue&type=style&index=0&id=23d26766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d26766",
  null
  
)

export default component.exports